import { ReactNode } from 'react';

import { useAuth } from './authProvider';

const palmettoFinanceOrgAlias = 'sabal';

export const isPalmettoFinanceUser = (claims: any) =>
  claims?.org === palmettoFinanceOrgAlias || claims?.rootOrg === palmettoFinanceOrgAlias;

export const HiddenLightReachInfoForEpcUser = ({
  children,
  fallbackChildren,
}: {
  children: ReactNode;
  fallbackChildren?: ReactNode;
}) => {
  const { claims } = useAuth();
  const show = isPalmettoFinanceUser(claims);
  return show ? <>{children}</> : fallbackChildren ? <>{fallbackChildren}</> : null;
};
